<template>
  <div class="tabs" :class="{ commercialDataTab: category.id === 'commerces-de-vente-au-detail'}">
    <div class="category tab" :id="'tab--'+category.id">
      <input type="checkbox" :id="category.id">
      <div class="tab-label" :class="{deactivated: !category.selected}">
        <div class="close" @click="toggleSelected(!value)"><i :id="'eye--'+category.id" :class="eyeOpen(value,category.id)"></i></div>
        <label class="tab-label-controller" :for="category.id">
          <span class="tab-label-text" >
              {{ category['label_' + $i18n.locale] }} <b> {{ category.nb ? '('+category.nb+')' : ``}} </b>
          </span>
        </label>
      </div>
      <div v-if="category.id !== 'commerces-de-vente-au-detail'" class="tab-content">
        <sub-cat-filters v-for="subcat in category.subCats" :key="subcat.id" :subcat="subcat" v-model="subcat.selected"/>
      </div>
      <div v-if="category.id === 'commerces-de-vente-au-detail'" class="tab-content">
        <type-filters v-for="type in category.types" :key="type.id" :type="type" v-model="type.selected"/>
      </div>
    </div>
  </div>
</template>

<script>
import SubCatFilters from './SubCatFilters'
import TypeFilters from './TypeFilters'
import _ from 'lodash'
export default {
  props: ['category', 'value'],
  components: {
    SubCatFilters,
    TypeFilters
  },
  methods: {
    toggleSelected (newValue) {
      const category = _.cloneDeep(this.category)
      category.selected = newValue
      if (category.subCats) {
        category.subCats.map(subcat => {
          subcat.selected = newValue
        })
      }
      if (category.types) {
        category.types.map(type => {
          type.selected = newValue
        })
      }
      this.$emit('updateCategory', category)
    },
    async eyeOpen (value, subcatID) {
      // Wait until the dom element is generated

      while (!document.querySelector(`#eye--${subcatID}`)) {
        await new Promise(resolve => setTimeout(resolve, 100))
      }

      if (subcatID != null) {
      // console.log(subcatID)
        var id = document.getElementById(`eye--${subcatID}`)
        if (value) {
          id.className = 'far fa-eye'
        } else {
          id.className = 'far fa-eye-slash'
        }
      }
    }
  }
}
</script>

<style lang="scss">

$open: #bababa;
$clouds: #ecf0f1;

input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.close {
  padding: 0px 16px;
  font-weight: bold;
  cursor: pointer;
}

/* Accordion styles */
.tabs {
  border: #00000052 solid 1px;
  margin: 10px 10px;
  border-radius: 1px;
  overflow: hidden;
  box-shadow: 0 1px 1px 0px rgba(0,0,0,0.5);
}
.tab {
  opacity: 1;
  // &.deactivated {
  //   opacity: 0.2;
  //   .tab-content {
  //     // pointer-events: none;
  //   }
  // }
  width: 100%;
  overflow: hidden;
  &-label {
    &.deactivated {
      opacity: 0.3;
    }
    padding: 5px 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &-text {
      flex-grow: 1;
      text-align: left;
      padding: 3px 0px;
      cursor: pointer;
      &:hover {
        opacity: 0.5;
      }
    }
    &:hover {
      // background: $open;
    }
    &-controller {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px;
      width: 100%;
      cursor: pointer;
      /* Icon */
      &::after {
      content: "\276F";
      width: 1em;
      height: 1em;
      text-align: right;
      transition: all .35s;
      padding: 10px
    }
    }
  }
  &-content {
    max-height: 0;
    padding: 0 1em;
    color: black;
    background: white;
    transition: all .35s;
  }
  &-close {
    opacity: 0.1;
    display: flex;
    justify-content: flex-end;
    padding: 1em;
    font-size: 0.75em;
    // background: $open;
    cursor: pointer;
    &:hover {
      // background: darken($open, 10%);
    }
  }
}

// :checked
input:checked {
  + .tab-label  {
    // background: darken($open, 10%);
    .tab-label-controller {
      &::after {
        transform: rotate(90deg);
      }
    }
  }
  ~ .tab-content {
    max-height: 100vh;
    padding: 1em;
    background-color: inherit;
  }
}
</style>
